export { default as CarouselStories } from './CarouselStories';